import { useEffect, useState } from "react";
import { INIT_FORM } from "../constants";
import { requestGetMassiveAcadReinforceById, requestUpdateMassiveAcadReinforceById } from "services/acadReinforce/aboutAcadReinforce";
import useMainContext from "utils/context/useMainContext";

const useForm = ({
    loadingRequest, toastMessageSuccess,
    acadReinforceId, dialogShow,
    fillAcadReinforceList
}) => {
    const mainContext = useMainContext();
    //#region States
    const [form, setForm] = useState({ ...INIT_FORM });
    const [isLoadedFormData, setIsLoadedFormData] = useState(false);
    const [isValidForm, setIsValidForm] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (dialogShow.value) {
            fillForm();        
            return;
        }
        clearForm();
        setIsLoadedFormData(false);
    }, [dialogShow.value]);
    useEffect(() => {
        setIsValidForm(checkIsValidForm());
    }, [form]);
    //#endregion
    //#region Functions
    const fillForm = async () => {
        try {
            loadingRequest.show("Cargando refuerzo...");
            const data = await requestGetMassiveAcadReinforceById(acadReinforceId);
            if (!data) {
                dialogShow.set(false);
                mainContext.setShowDialogUnexpectedError(true);
                return;
            }
            setForm(prev => ({
                ...prev,
                ...data
            }));
            setIsLoadedFormData(true);
        }
        finally {
            loadingRequest.hide();
        }
    }
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
    }
    const checkIsValidForm = () => {
        const {
            campusDetailId, environmentTypeId,
            quantityVacancy, date, timeStart, 
            timeEnd, environment
        } = form;
        return (
            campusDetailId > 0 && 
            environmentTypeId.length > 0 && 
            Number(quantityVacancy) > 0 &&
            date > -1 && timeStart > -1 &&
            timeEnd > -1 && timeEnd > timeStart && 
            environment.id.length > 0 
        );
    }
    const updateAcadReinforce = async () => {
        loadingRequest.show("Actualizando refuerzo...");
        const { success, message } = await requestUpdateMassiveAcadReinforceById({
            ...form,
            id: acadReinforceId
        });
        loadingRequest.hide();
        if (success) {
            dialogShow.set(false);
            await fillAcadReinforceList();
            toastMessageSuccess.show("¡El refuerzo fue actualizado exitosamente!");
            return;
        }
        switch (message) {
            case "LISTO_PARA_SINCRONIZAR": 
                mainContext.setDialogUnexpectedErrorMessage("Este refuerzo ya está listo para sincronizarse.");
                break;
        }
        mainContext.setShowDialogUnexpectedError(true);
    }
    const clearForm = () => {
        setForm({ ...INIT_FORM });
    }
    //#endregion
    return {
        value: form, isValid: isValidForm,
        change: changeField, isLoaded: isLoadedFormData,
        update: updateAcadReinforce,
        clear: clearForm
    };
}

export default useForm;